import { privateAxiosIntance } from "../../Config/axios";
import { API_URLS } from "../../Config/urls";

export const CustomerListFn = (reqBody) => {
  try {
    const response = privateAxiosIntance.get(API_URLS.customer_list, {
      params: reqBody,
      headers: {
        Token: localStorage.getItem("Token"), // ← send token here
      },
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const ChatListFn = (reqBody) => {
  try {
    const response = privateAxiosIntance.get(API_URLS.chat_list, {
      params: reqBody,
      headers: {
        Token: localStorage.getItem("Token"),
      },
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const getChatAgentQAFn = (reqBody) => {
  try {
    const response = privateAxiosIntance.get(API_URLS.chat_qa, {
      params: reqBody,
      headers: {
        Token: localStorage.getItem("Token"),
      },
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const PostChatAgentQAFn = (reqBody) => {
  try {
    const response = privateAxiosIntance.post(API_URLS.chat_qa, reqBody, {
      headers: {
        Token: localStorage.getItem("Token"),
      },
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const PatchChatAgentQAFn = (reqBody) => {
  try {
    const response = privateAxiosIntance.patch(API_URLS.chat_qa, reqBody, {
      headers: {
        Token: localStorage.getItem("Token"),
      },
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const deleteChatAgentQAFn = (reqBody) => {
  try {
    const response = privateAxiosIntance.delete(API_URLS.chat_qa, {
      data: reqBody,
      headers: {
        Token: localStorage.getItem("Token"),
      },
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const BotMessageListFn = (reqBody) => {
  try {
    const response = privateAxiosIntance.get(API_URLS.chat_bot_msg, {
      params: reqBody,
      headers: {
        Token: localStorage.getItem("Token"),
      },
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};
export const PostBotMessageListFn = (reqBody) => {
  try {
    const response = privateAxiosIntance.post(API_URLS.chat_bot_msg, reqBody, {
      headers: {
        Token: localStorage.getItem("Token"),
      },
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const PatchBotMessageListFn = (reqBody) => {
  try {
    const response = privateAxiosIntance.patch(API_URLS.chat_bot_msg, reqBody, {
      headers: {
        Token: localStorage.getItem("Token"),
      },
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const DeleteBotMessageListFn = (reqBody) => {
  try {
    const response = privateAxiosIntance.delete(API_URLS.chat_bot_msg, {
      data: reqBody,
      headers: {
        Token: localStorage.getItem("Token"),
      },
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const UnmatchedListFn = (reqBody) => {
  try {
    const response = privateAxiosIntance.get(API_URLS.unmatched, {
      params: reqBody,
      headers: {
        Token: localStorage.getItem("Token"), // ← send token here
      },
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const DeleteUnmatchedListFn = (reqBody) => {
  try {
    const response = privateAxiosIntance.delete(API_URLS.unmatched, {
      data: reqBody,
      headers: {
        Token: localStorage.getItem("Token"), // ← send token here
      },
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const waitingListFn = (reqBody) => {
  try {
    const response = privateAxiosIntance.get(API_URLS.waitinguser, {
      params: reqBody,
      headers: {
        Token: localStorage.getItem("Token"), // ← send token here
      },
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};
